import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import './ui/styles/index.css';
import { initRemoteDebugLog } from './utils/RemoteDebugLog';
import { installSearchBaselineProbe } from './features/hybridApply/searchBaselineProbe';

/* global Office */

// Initialize the app
const initApp = () => {
  initRemoteDebugLog();
  // T-001 spike: expose window.__courtyardProbeSearchBaseline for the search-baseline capture.
  installSearchBaselineProbe();
  const container = document.getElementById('root');
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
};

// Check if Office.js is available
if (typeof Office !== 'undefined' && Office.onReady) {
  let initialized = false;
  const initOnce = () => {
    if (initialized) return;
    initialized = true;
    initApp();
  };

  const officeFallbackTimer = window.setTimeout(() => {
    console.warn('Office.onReady did not resolve quickly - rendering diagnostic browser mode');
    initOnce();
  }, 3000);

  Office.onReady((info) => {
    window.clearTimeout(officeFallbackTimer);
    if (info.host === Office.HostType.Word) {
      initOnce();
    } else {
      console.warn('Add-in is not running in Word');
      initOnce(); // Still render for testing
    }
  });
} else {
  // Office.js not available (testing in browser)
  console.warn('Office.js not available - running in browser mode');
  initApp();
}

